import { isBoostPlayerBonus } from "./typeGuards";
export function shouldDisplayBonusInelligibleBadge(playerBonus, selection) {
    return isBoostPlayerBonus(playerBonus) && !selection.isInBetBoost;
}
//# sourceMappingURL=shouldDisplayBonusInelligibleBadge.js.map